import React from 'react';
import Styled from 'styled';
import defaultStyles from './skeleton-group.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class SkeletonGroup extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.container}>
                <div className={styles.image} />
                <div className={styles.groupName} />
                {[1, 2].map(index => (
                    <div className={styles.groupDescription} key={index} />
                ))}
                <div className={styles.groupDescriptionLast} />
                <div className={styles.groupStats}>
                    <div />
                    <div />
                </div>
                <div className={styles.addToGroupButton} />
            </div>
        );
    }
}

export default Styled(defaultStyles)(SkeletonGroup);
